<script setup lang="ts">
const router = useRouter();
const route = useRoute();
const isLoading = ref(true);
const canonicalEl = ref<HTMLLinkElement | null>(null);

async function loadApp() {
  await router.isReady();
  isLoading.value = false;
}

onMounted(() => {
  loadApp();
  canonicalEl.value = document.querySelector('link[rel="canonical"]');
});

watch(
  () => route.path,
  () => {
    if (canonicalEl.value) {
      const href = canonicalEl.value.href;
      const baseURL = new URL(href).origin;
      canonicalEl.value.setAttribute("href", baseURL + (route.path === "/" ? "" : route.path));
    }
  }
);
</script>

<template>
  <div v-show="isLoading">
    <div class="bg-text-dark fixed top-0 right-0 bottom-0 left-0 flex items-center justify-center">
      <svg width="1200" height="630" viewBox="0 0 46 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_412_6521)">
          <path
            d="M22.8657 2.76489L33.1408 20.5608L43.4159 38.3567H22.8657H2.31543L12.5905 20.5608L22.8657 2.76489Z"
            fill="#070707"
            stroke="#D80000"
            stroke-width="2"
            stroke-miterlimit="10"
          />
          <path
            d="M24.2612 10.343H21.4708C21.4357 10.343 21.4072 10.3715 21.4072 10.4066V17.9953C21.4072 18.0304 21.4357 18.0589 21.4708 18.0589H24.2612C24.2963 18.0589 24.3248 18.0304 24.3248 17.9953V10.4066C24.3248 10.3715 24.2963 10.343 24.2612 10.343Z"
            fill="white"
          />
          <path
            d="M30.9699 24.528L32.3099 26.9261C32.3227 26.9494 32.3057 26.9791 32.2781 26.9791H15.5784C13.9034 26.9791 12.8665 25.1556 13.7231 23.718L15.7035 20.3849C16.1149 19.6724 16.8739 19.2335 17.6966 19.2335H27.8848C27.9187 19.2335 27.9484 19.2526 27.9654 19.2823L29.2482 21.6507C29.263 21.6783 29.2439 21.7122 29.2121 21.7122H18.0338C17.9341 21.7122 17.8408 21.7652 17.792 21.8521L16.3587 24.3329C16.3163 24.4071 16.3693 24.5004 16.4562 24.5004H30.9254C30.9444 24.5004 30.9614 24.511 30.972 24.528H30.9699Z"
            fill="white"
          />
          <path
            d="M38.1379 35.8548H34.8556C34.8323 35.8548 34.8111 35.842 34.8005 35.823L31.7069 30.4967C31.69 30.4691 31.656 30.4585 31.6285 30.4691L24.7247 33.3485C24.7247 33.3485 24.7077 33.3528 24.6992 33.3528H21.0311C21.0311 33.3528 21.0141 33.3528 21.0056 33.3485L14.1018 30.4691C14.0722 30.4564 14.0382 30.4691 14.0234 30.4967L10.9298 35.823C10.9192 35.842 10.898 35.8548 10.8747 35.8548H7.59243C7.54367 35.8548 7.51186 35.8018 7.53731 35.7594L11.9561 28.1431C11.9667 28.124 11.9879 28.1113 12.0112 28.1113H15.1154C15.1154 28.1113 15.1323 28.1113 15.1408 28.1156L22.8418 31.3618C22.8567 31.3682 22.8758 31.3682 22.8906 31.3618L30.5916 28.1156C30.5916 28.1156 30.6086 28.1113 30.6171 28.1113H33.7212C33.7446 28.1113 33.7658 28.124 33.7764 28.1431L38.1951 35.7594C38.2206 35.8018 38.1888 35.8548 38.14 35.8548H38.1379Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_412_6521">
            <rect width="45.7525" height="40" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  </div>
  <div v-show="!isLoading">
    <header-bar class="absolute top-0 right-0 left-0"></header-bar>
    <router-view></router-view>
    <footer-comp></footer-comp>
  </div>
</template>
